import { Toaster } from 'sonner'

import Router from './routes/sections'
import { ThemeProvider } from './components/theme-provider'
import { AuthProvider } from './contexts/auth-context/auth-provider'

export default function App() {
  // const [userData, setUserData] = useState<User | null>(null)

  return (
    <ThemeProvider>
      {/* <AuthProvider getUser={setUserData}> */}
      <AuthProvider>
        <Router />
      </AuthProvider>
      <Toaster expand={true} richColors closeButton />
      {/* <PwaInstallPopup user={userData} /> */}
    </ThemeProvider>
  )
}
